import { Checkbox } from '../components'

// interface Props {
//   // config: DeviceConfigData
//   // sensorNumber: string
//   // sensorDescription: string
// }

export function SensorPage() {
  const config = {
    name: 'RICProto_888',
    serialNumber: 1293012,
    firmwareVersion: '3.1.2',
    hardwareVersion: '1.0',
    wisolId: '40DA17',
    latitude: 51.13187789917,
    longitude: -114.15043640137,
    elevation: 1242.9000244141,
    siteCode: '',
    siteName: '',
    batteryReading: '24 hrs',
    sensorReading: '15 min',
    sensorA1: 'Vegetronix VH400',
    sensorA2: '',
    sensorB1: 'Irrometer WM200SS',
    sensorB2: '',
    sensorC1: '',
    sensorC2: '',
  }

  const sensorNumber = 'A1'
  const sensorDescription = config.sensorA1

  const list = [
    'View sensor warnings',
    'View raw sensor value',
    'View reading',
    'View change from previous reading',
    'View delta (difference) from reference value _____ %  [__] Invert Equation',
    'View volume, calculated from rate reading (paddlewheel only)',
    'View volume rate, calculated from pulse readings (SDI only)',
    'View total volume, calculated since 2018-01-01 00:00 (SDI and paddlewheel only)',
    'Create warning if reading is higher than _____',
    'Create warning if reading is lower than _____',
    'Use delta value (rather than reading value) when creating warnings that exceed high and low values',
    'Create warning if reading changes by more than _____ % since previous reading',
  ]

  return (
    <div className={tailwind.container}>
      <h2>Sensor Page</h2>
      <table className="w-full table-auto">
        <tbody>
          <tr className="border-y-2 border-x-gray-400">
            <td>
              <b>Name:</b> {config.name}
            </td>
            <td>
              <b>Serial Number:</b> {config.serialNumber}
            </td>
          </tr>
          <tr className="border-y-2 border-x-gray-400">
            <td>
              <b>Sensor {sensorNumber}:</b> {sensorDescription}
            </td>
          </tr>
        </tbody>
      </table>

      <div>
        <div className="form-check">
          {list.map((label) => (
            <Checkbox label={label} />
          ))}
        </div>
      </div>
    </div>
  )
}

const tailwind = {
  container: 'mt-3 mx-10',
}
